import _ from 'underscore';
import { BaseValidator } from './base-validator';
import { validateColor } from './custom/validate-color';

const RegistedHandlers = {
  color: validateColor,
};

export class CustomValidator extends BaseValidator {
  constructor(propertySchema) {
    super(propertySchema);

    const { custom } = propertySchema;

    if (_.isString(custom)) {
      this.validateFunc = RegistedHandlers[custom];
    }
  }

  get requiredField() {
    return 'custom';
  }

  internalValidate(propertyValue) {
    if (!this.validateFunc) {
      throw new Error('Invalid value for custom key');
    }

    return this.validateFunc(propertyValue);
  }
}
